// Frans (fr-FR), homeApp: zelfde vorm als homeApp.nl.ts (golf 6b). Tutoiement comme app.fr.ts;
// espace fine insécable (U+202F) avant : ; ! ? et %. La météo ne parle jamais de prière (neutre).
export const appHomeFr = {
    customize: 'Personnaliser',
    customizeLabel: 'Personnaliser Aujourd’hui',
    done: 'Terminé',
    intro: 'Mettez sur Aujourd’hui ce qui compte pour vous. Faites glisser une carte ailleurs, agrandissez-la ou réduisez-la par son bord ou son coin, ou choisissez S, M ou L.',
    /** Telefoon: alleen de volgorde (feat/vandaag-raster). */
    introList: 'Rangez les cartes dans l’ordre voulu : faites glisser la poignée ou utilisez les flèches. Sur un écran plus grand, vous pouvez aussi les placer librement et les agrandir ou les réduire.',
    undo: 'Annuler',
    undone: 'La dernière modification a été annulée.',
    /** Raster (computer en tablet): zoals de bord-editor. */
    gridHint: 'Grille d’Aujourd’hui : faites glisser une carte ailleurs, tirez sur son bord ou son coin pour la réduire ou l’agrandir.',
    cardAt: '{name}, {w} sur {h} cases, colonne {x}, ligne {y}',
    keysHint: 'Flèches : déplacer. Maj et flèches : réduire ou agrandir.',
    noRoom: 'Ça ne rentre pas ici. Réduisez ou retirez d’abord quelque chose.',
    size: 'Taille',
    sizes: { S: 'Petit', M: 'Moyen', L: 'Grand' },
    fitMore: '+{count} de plus',
    fitMoreAll: 'Voir plus',
    reset: 'Rétablir par défaut',
    resetDone: 'Aujourd’hui est revenu comme avant.',
    saveFailed: 'L’enregistrement n’a pas marché. Réessaie dans un instant.',
    add: 'Ajouter une carte',
    addTitle: 'Ajouter une carte',
    addNothing: 'Toutes les cartes sont déjà là.',
    moveUp: 'Monter {name}',
    moveDown: 'Descendre {name}',
    remove: 'Retirer {name}',
    removed: '{name} a été retiré.',
    added: '{name} est maintenant sur Aujourd’hui.',
    drag: 'Déplacer {name}',
    position: '{name} est maintenant à la place {pos} sur {count}.',
    empty: 'Aujourd’hui est encore vide.',
    emptyBody: 'Touche Personnaliser et choisis ce que tu veux voir ici.',
    emptyEdit: 'Pas encore de cartes. Ajoutes-en une ci-dessous.',
    quiet: 'Rien à afficher pour l’instant. La carte apparaît d’elle-même quand il y a quelque chose.',
    widgets: {
        now: { name: 'En cours', description: 'Ce qui se passe maintenant ou commence bientôt' },
        agenda: { name: 'Agenda du jour', description: 'Tous les événements d’aujourd’hui' },
        tasks: { name: 'Tâches du jour', description: 'Où chacun en est dans ses tâches' },
        tomorrow: { name: 'Demain', description: 'Un coup d’œil aux événements de demain' },
        weather: { name: 'Météo', description: 'La météo et quoi porter, touche pour en savoir plus' },
        rides: { name: 'Trajets', description: 'Les trajets que personne ne fait encore' },
        prayer: { name: 'Heures de prière', description: 'Les heures d’aujourd’hui' },
        check_in: {
            name: 'Check-in quotidien',
            description: 'Si « Tout va bien » est arrivé aujourd’hui',
        },
        goals: { name: 'Épargne', description: 'Où en sont les enfants avec leur épargne' },
        shopping: { name: 'Courses', description: 'Ce qu’il reste à acheter' },
        messages: { name: 'Messages', description: 'Les nouveaux messages de la famille' },
        wishes: { name: 'Souhaits', description: 'Les souhaits des enfants' },
        rotation: {
            name: 'Planning des tâches',
            description: 'Qui fait quoi cette semaine et qui cuisine aujourd’hui',
        },
        // Golf 8 (0049): Samen wonen.
        dinner: { name: 'Dîner ce soir', description: 'Qui mange et ton choix' },
        bookings: { name: 'Réservations', description: 'Ta prochaine réservation et ce qui est libre' },
        balance: { name: 'Dépenses', description: 'Seulement ton propre solde' },
        // 0069: Geldzaken (alleen in je eigen omgeving).
        money: { name: 'Finances', description: 'Ce qui est resté ce mois-ci (toi seul)' },
        todos: { name: 'À faire', description: 'Tes tâches à faire ouvertes, avec la date limite' },
        // 0076: schoolplanner.
        school: {
            name: 'Devoirs et contrôles',
            description: 'Les devoirs du jour, les contrôles à venir et les notes à saisir',
        },
        // 0075: Huisronde (module Eten).
        house_round: {
            name: 'Tour de la maison',
            description: 'Le prochain tour de la maison, et le lancer',
        },
    },
    shopping: {
        open: { one: '{count} chose à acheter', other: '{count} choses à acheter' },
        empty: 'Tout a été acheté.',
        all: 'Vers les courses',
        more: '+{count} de plus',
    },
    messages: {
        unread: { one: '{count} nouveau message', other: '{count} nouveaux messages' },
        none: 'Pas de nouveaux messages.',
        all: 'Vers les messages',
        voice: 'Message vocal',
        sticker: 'Autocollant',
        pictos: 'Images',
    },
    wishes: {
        count: { one: '{count} souhait', other: '{count} souhaits' },
        empty: 'Pas encore de souhaits.',
        all: 'Vers les souhaits',
    },
    /** Golf 6b fixer r1: widget Beurtrooster (huisgenoten). */
    rotation: {
        you: 'Toi cette semaine',
        done: 'Fait',
        open: 'Pas encore fait',
        noneForYou: 'Tu n’as pas de tour cette semaine.',
        cooks: '{name} cuisine aujourd’hui',
        youCook: 'Tu cuisines aujourd’hui',
        others: 'Le reste de la maison',
        all: 'Vers le planning',
        empty: 'Pas encore de planning.',
    },
    prayer: {
        next: 'Ensuite',
        settings: 'Réglages',
        fromTable: 'D’après le calendrier de ta mosquée',
    },
};
export const appAgendaViewsFr = {
    day: 'Jour',
    workweek: 'Semaine de travail',
    week: 'Semaine',
    month: 'Mois',
    workweekTitle: 'Semaine de travail {week} · {range}',
    emptyWorkweek: 'Rien de prévu cette semaine de travail pour l’instant',
    prev: {
        day: 'Jour précédent',
        workweek: 'Semaine de travail précédente',
        week: 'Semaine précédente',
        month: 'Mois précédent',
    },
    next: {
        day: 'Jour suivant',
        workweek: 'Semaine de travail suivante',
        week: 'Semaine suivante',
        month: 'Mois suivant',
    },
    keys: 'Raccourcis : ← et → pour naviguer, T pour aujourd’hui.',
};
export const appWeatherDetailFr = {
    open: 'En savoir plus sur la météo',
    titleToday: 'La météo aujourd’hui',
    titleTomorrow: 'La météo demain',
    today: 'Aujourd’hui',
    tomorrow: 'Demain',
    temp: 'Température',
    tempRange: 'de {min}° à {max}°',
    feels: 'Température ressentie',
    feelsRange: 'de {min}° à {max}°',
    feelsDay: 'environ {value}° en journée',
    rain: 'Pluie',
    rainChance: {
        dry: 'Sec',
        small: 'Faible risque d’averse',
        likely: 'Risque de pluie',
        wet: 'Pluvieux',
    },
    rainAmount: '{mm} mm',
    rainHours: { one: 'en {count} heure', other: 'en {count} heures' },
    rainWhen: 'entre {from} et {until}',
    rainPct: '{pct} % de risque',
    rainNoPct: 'Pour les Pays-Bas, MET Norway ne donne pas de probabilité en pourcentage. Voici la quantité prévue.',
    wind: 'Vent',
    windForce: 'Force {bft}',
    windFrom: 'vent {dir}',
    windSpeed: '{kmh} km/h',
    bft: [
        'calme',
        'très légère brise',
        'légère brise',
        'petite brise',
        'jolie brise',
        'bonne brise',
        'vent frais',
        'grand frais',
        'coup de vent',
        'fort coup de vent',
        'tempête',
        'violente tempête',
        'ouragan',
    ],
    dirs: {
        N: 'du nord',
        NE: 'du nord-est',
        E: 'd’est',
        SE: 'du sud-est',
        S: 'du sud',
        SW: 'du sud-ouest',
        W: 'd’ouest',
        NW: 'du nord-ouest',
    },
    dirShort: { N: 'N', NE: 'NE', E: 'E', SE: 'SE', S: 'S', SW: 'SO', W: 'O', NW: 'NO' },
    uv: 'Indice UV',
    uvLevels: {
        low: 'faible',
        moderate: 'modéré',
        high: 'élevé',
        very_high: 'très élevé',
        extreme: 'extrême',
    },
    uvValue: 'UV {value}, {level}',
    uvClearSky: 'par ciel dégagé',
    sun: 'Soleil',
    sunrise: 'Lever {time}',
    sunset: 'Coucher {time}',
    course: 'Au fil de la journée',
    courseOpen: 'Heure par heure',
    back: 'Retour',
    courseTemp: 'Température (°C)',
    courseRain: 'Précipitations (mm par heure)',
    courseHour: '{time} : {temp}°, {rain} mm, force {bft}',
    partial: 'Toutes les heures de cette journée ne sont pas encore connues.',
    now: 'Maintenant',
    close: 'Fermer',
    symbols: {
        clear: 'ensoleillé',
        partly_cloudy: 'partiellement nuageux',
        cloudy: 'nuageux',
        fog: 'brouillard',
        drizzle: 'bruine',
        rain: 'pluie',
        heavy_rain: 'forte pluie',
        sleet: 'neige fondue',
        snow: 'neige',
        thunder: 'orage',
    },
};
//# sourceMappingURL=homeApp.fr.js.map